import type { ReactNode } from "react";
import { Text } from "react-native";
import type { StyleProp, TextStyle } from "react-native";
import { semanticColors } from "../theme/tokens";
import { SupportingSubtitleText } from "./SupportingSubtitleText";

type Props = {
  children: ReactNode;
  numberOfLines?: number;
  style?: StyleProp<TextStyle>;
};

export type EmptyStateTitleVariant = "compact" | "featured";

/** Shared title role for empty and completed state banners. */
export function EmptyStateTitleText({
  children,
  numberOfLines,
  style,
  variant = "compact",
}: Props & { variant?: EmptyStateTitleVariant }) {
  const featured = variant === "featured";
  return (
    <Text
      className="font-dm-sans"
      numberOfLines={numberOfLines}
      style={[
        {
          fontSize: featured ? 16 : 14,
          lineHeight: featured ? 22 : 18,
          color: semanticColors.text.primary,
          fontWeight: featured ? "600" : "700",
        },
        style,
      ]}
    >
      {children}
    </Text>
  );
}

/** Empty/completed-state copy uses the same supporting typography as rows. */
export function EmptyStateSubtitleText({
  children,
  numberOfLines,
  style,
}: Props) {
  return (
    <SupportingSubtitleText
      numberOfLines={numberOfLines}
      style={[{ marginTop: 1 }, style]}
    >
      {children}
    </SupportingSubtitleText>
  );
}
